import { Component, OnInit, ChangeDetectorRef, ViewChild, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, NgForm } from '@angular/forms';
import { CommonHelper } from '../../../../../core/_config/common.helper';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { ProfileComponent } from '../../../../../views/pages/profile/profile.component';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { PersonalDetailsService } from './personal-details.service';
import { decrypt, encrypt } from '../../../../../utilities/utilityFunctions';
import { nationalityDetails, personalDetails } from './model/personalModel';
// import { Ng2ImgMaxService } from 'ng2-img-max';
import { NgxImageCompressService } from 'ngx-image-compress';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';
import { TransitionCheckState } from '@angular/material';
import moment from 'moment';
@Component({
	selector: 'kt-personal-details',
	templateUrl: './personal-details.component.html',
	styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit {
	public nationalityDetilsForm: FormGroup;
	@ViewChild('personalDetailsForm', { static: false }) personalDetailsForm: NgForm;
	@Input('personalDetailsData') personalDetailsData: personalDetails;
	@Input('nationalityData') nationalityData: nationalityDetails[];
	@Input('dropdownList') dropdownList: any;
	public nationalityList: any;
	public nationalityCountRow = 0;
	public nationality: number = 0;
	private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.imageFileExt;
	private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
	private selectedFilePayload: any;
	private attachmentBase64: string;
	public profileAvatarImg: string;
	public domicileDistrict: any;
	public domicileCities: any
	public fatherStatusValue: number;
	public editForm: boolean = false;
	public birthCountryValue: number;
	public alertMsgValue: string;
	public isAlertVisible: boolean = false;
	public isImageAlert: boolean = false;
	public alertType: string;
	public alertIcon: string;
	public isAddNewNationality: boolean = false;
	@Input('isLocked') isLocked: boolean = true;

	public dropdownValues: any = { genderValue: '', maritalValue: '', countryValue: '', religionValue: '', identityValue: '' };
	constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef, private sharedServices: SharedService,
		private profileComp: ProfileComponent, private personalDetailsService: PersonalDetailsService,
		// private ng2ImgMax: Ng2ImgMaxService, 
		private imageCompress: NgxImageCompressService,
		private loaderService: LoaderService) { }

	ngOnInit() {
		window.scroll(0, 0)
		if (localStorage.getItem('Avatar') != undefined && localStorage.getItem('Avatar') != '') {
			this.profileAvatarImg = decrypt(localStorage.getItem('Avatar'))
		} else {
			this.profileAvatarImg = '/assets/media/users/default.jpg';
		}
		if (this.personalDetailsData.dateOfBirth) {
			this.personalDetailsData.dateOfBirth = new Date(this.personalDetailsData.dateOfBirth).toDateString()
			this.getBirthCountry(this.personalDetailsData.countryOfBirth)
		} else if (this.personalDetailsData.countryOfBirth) {
			this.getBirthCountry(this.personalDetailsData.countryOfBirth)
			this.getEditForm();
		}
		else {
			this.getEditForm();
		}
		if (this.personalDetailsData.countryOfBirth == 1) {
			this.getDomicileId(this.personalDetailsData.domicileDistrictId)
		}
		if (this.nationalityData.length == 0) {
		}
	}

	public createNationalityForm(): void {
		this.nationalityDetilsForm = this.fb.group({
			nationalityDtos: this.fb.array([
			]),
			nationalityDtosNew: this.fb.array([
			])
		})
	}

	public getBirthCountry(birthCountry): void {
		this.birthCountryValue = birthCountry;
	}

	public getFatherStatus(fatherStatus): void {
		this.fatherStatusValue = fatherStatus;
		this.cdr.detectChanges()
	}

	getDomicileId(e): void {
		if (e) {
			this.personalDetailsService.getProvinceCitiesValue(e).subscribe(
				(res: HecResponse) => {
					this.domicileCities = res.data;
					this.cdr.detectChanges();
				}
			)
			this.personalDetailsService.getProvinceDistrictValue(e).subscribe(
				(res: HecResponse) => {
					this.domicileDistrict = res.data
					this.cdr.detectChanges();
				}
			)
		}
	}

	public addMore(): void {
		this.nationalityCountRow = this.nationalityCountRow + 1;
		this.nationalityList = this.nationalityDetilsForm.controls.nationalityDtos as FormArray;
		if ((this.nationalityList.length + 1) <= this.nationalityCountRow) {
			this.nationalityList.push(this.createNewNationalityRow());
		}
		this.nationality++;
	}


	public createNewNationalityRow() {
		return this.fb.group({
			identityNo: new FormControl('', Validators.required),
			identityTypeCode: new FormControl('', Validators.required),
			countryId: new FormControl('', Validators.required),
			id: new FormControl(),
			primary: new FormControl(),
			countryName: new FormControl(),
			activeIndicator: new FormControl(),
			creationTime: new FormControl()
		});
	}


	public getNationality(): void {
		return this.nationalityDetilsForm.controls.nationalityDtos['controls'];
	}

	public deleteNationalityRow(nationalityIndex): void {
		if (this.nationality > 0) {
			const nationlityForm = this.nationalityDetilsForm.controls.nationalityDtos as FormArray;
			nationlityForm.removeAt(nationalityIndex);
			this.nationality--;
		}
	}

	public submitProfile(): void {
		let canSubmit = true;

		this.isAlertVisible = false;

		if (this.isAddNewNationality) {
			this.markFormsTouched(this.nationalityDetilsForm)
			if (!this.validate(this.nationalityDetilsForm)) {
				canSubmit = false;
				this.cdr.detectChanges();
				this.cdr.markForCheck();
			}
			else {
				const cantAdd = this.nationalityData.some(item => (Number.parseInt(this.nationalityDetilsForm.value.nationalityDtosNew[0].countryId) === item.countryId) && (Number.parseInt(this.nationalityDetilsForm.value.nationalityDtosNew[0].identityTypeCode) === item.identityTypeCode));

				if (!cantAdd) this.nationalityDetilsForm.value.nationalityDtos.push(this.nationalityDetilsForm.value.nationalityDtosNew[0]);
			}
		}

		if (canSubmit) {
			this.markFormsTouched(this.personalDetailsForm)
			this.markFormsTouched(this.nationalityDetilsForm)
			if (this.validate(this.personalDetailsForm)) {
				if (this.validate(this.nationalityDetilsForm)) {
					this.loaderService.setValue(true)
					for (let i = 0; i < this.dropdownList.titleList['length']; i++) {
						if (this.dropdownList.titleList[i].value == this.personalDetailsForm.value.titleId) {
							this.personalDetailsForm.value.title = this.dropdownList.titleList[i].label;
						}
					}
					for (let i = 0; i < this.dropdownList.aliveDeceasedList['length']; i++) {
						if (this.dropdownList.aliveDeceasedList[i].value == this.personalDetailsForm.value.fatherStatusId) {
							this.personalDetailsForm.value.fatherStatus = this.dropdownList.aliveDeceasedList[i].label;
						}
					}
					if (this.personalDetailsForm.value.countryOfBirth != 1) {
						this.personalDetailsForm.value.domicileDistrictId == null;
						this.personalDetailsForm.value.cityId == null;
						this.personalDetailsForm.value.districtId == null;

					}
					for (let i = 0; i < this.nationalityDetilsForm.controls.nationalityDtos['controls'].length; i++) {
						if (this.nationalityDetilsForm.controls.nationalityDtos['controls'][i].dirty) {
							this.nationalityDetilsForm.value.nationalityDtos[i].isUpdated = true;
						} else {
							this.nationalityDetilsForm.value.nationalityDtos[i].isUpdated = false;
						}
					}
					for (let i = 0; i < this.nationalityDetilsForm.value.nationalityDtos.length; i++) {
						if (this.nationalityDetilsForm.value.nationalityDtos[i].primary == null) {
							this.nationalityDetilsForm.value.nationalityDtos[i].primary = false;
						}
					}

					if (this.personalDetailsForm.form.controls.firstName.dirty || this.personalDetailsForm.form.controls.lastName.dirty ||
						this.personalDetailsForm.form.controls.middleName.dirty) {
						let data = decrypt(localStorage.getItem('esp-profile-details'));
						data = JSON.parse(data);
						if (this.personalDetailsForm.value.middleName) {
							data.fullName = this.personalDetailsForm.value.firstName + ' ' + this.personalDetailsForm.value.middleName + ' ' + this.personalDetailsForm.value.lastName;
						} else {
							data.fullName = this.personalDetailsForm.value.firstName + ' ' + this.personalDetailsForm.value.lastName;
						}
						localStorage.removeItem('esp-profile-details');
						data = encrypt(JSON.stringify(data));
						localStorage.setItem('esp-profile-details', data);
						localStorage.setItem('updateInfo', encrypt('1'));

					}

					let personalDetail = {
						data: {
							personalDetail: this.personalDetailsForm.value,
							nationalityDtos: this.nationalityDetilsForm.value.nationalityDtos
						}
					}
					if (this.isLocked) {
						personalDetail.data.personalDetail.firstName = this.personalDetailsData.firstName
						personalDetail.data.personalDetail.lastName = this.personalDetailsData.lastName
						personalDetail.data.personalDetail.genderCode = this.personalDetailsData.genderCode
					}

					personalDetail.data.personalDetail.dateOfBirth = moment(this.personalDetailsForm.form.controls.dateOfBirth.value).format('YYYY-MM-DD')

					// personalDetail.data.personalDetail.birthDate = personalDetail.data.personalDetail.dateOfBirth;
					delete personalDetail.data.personalDetail.searchCtrl;
					this.personalDetailsService.postSaveUserProfile(personalDetail).subscribe(
						async (res: HecResponse) => {
							this.isAddNewNationality = false;
							if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
								if (this.personalDetailsForm.controls.firstName.dirty || this.personalDetailsForm.controls.lastName.dirty ||
									this.personalDetailsForm.controls.middleName.dirty) {
									let data = decrypt(localStorage.getItem('esp-profile-details'));
									data = JSON.parse(data);
									data.fullName = this.personalDetailsForm.value.firstName + ' ' + this.personalDetailsForm.value.middleName + ' ' + this.personalDetailsForm.value.lastName;
									localStorage.removeItem('esp-profile-details');
									data = encrypt(JSON.stringify(data));
									localStorage.setItem('esp-profile-details', data);
									localStorage.setItem('updateInfo', encrypt('1'));
								}
								await this.profileComp.getUserPersonalDetails();
								this.loaderService.setValue(false)
								this.isAlertVisible = true;
								this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.PROFILE_UPDATED_SUCCESS;
								this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
								this.cdr.detectChanges();
								setTimeout(() => {
									this.editForm = false;
									this.isAlertVisible = false;
									this.cdr.detectChanges();
								}, 2000)
							} else {
								this.loaderService.setValue(false)
								this.isAlertVisible = true;
								this.alertMsgValue = res.statusDescription;
								this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
								this.cdr.detectChanges();
								this.cdr.markForCheck();
								setTimeout(() => {
									this.isAlertVisible = false;
									this.cdr.detectChanges();
								}, 3000);
							}
						},
						(err) => {
							this.isAddNewNationality = false;
							this.loaderService.setValue(false)
							this.isAlertVisible = true;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
							this.cdr.detectChanges();
							this.cdr.markForCheck();
							setTimeout(() => {
								this.isAlertVisible = false;
								this.cdr.detectChanges();
							}, 3000);
						}
					)
				}
			} else {
				if (localStorage.getItem('Avatar') == undefined) {
					this.isImageAlert = true;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.PROFILE_PICTURE_ERROR;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.cdr.detectChanges();
				}

				return
			}
		}

	}

	public goNext() {
		this.profileComp.goNext();
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public getUserPicture(data) {
		this.profileComp.profileAvatarImg = data;

	}


	public getUserPersonalDetails() {
		return new Promise((resolve, reject) => {
			this.sharedServices.getPersonalDetails().subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.personalDetailsData = res.data.personalDetail;
						this.isLocked = res.data.islocked;
						this.cdr.detectChanges();
						resolve(this.personalDetailsData);
						resolve(this.isLocked);
					}
					(err) => {
					}
				}
			)
		})
			.catch(function (error) {
			})
	}

	public getEditForm() {
		this.editForm = true;
		this.createNationalityForm();
		if (this.nationalityData.length > 0) {
			for (let i = 0; i < this.nationalityData.length; i++) {
				this.addMore();
				if (this.nationalityData[0].primary == true || this.nationalityData.length == 1 || this.nationalityData[0].primary == false) {
					this.nationalityDetilsForm.controls.nationalityDtos['controls'][0].controls.identityNo.disable();
					this.nationalityDetilsForm.controls.nationalityDtos['controls'][0].controls.countryId.disable();
					this.nationalityDetilsForm.controls.nationalityDtos['controls'][0].controls.identityTypeCode.disable();
				}
			}
		}
		this.nationalityDetilsForm.controls.nationalityDtos.setValue(this.nationalityData)
		for (let i = 0; i < this.dropdownList.maritalStatusList.length; i++) {
			this.dropdownList.maritalStatusList[i].id = 'a' + this.dropdownList.maritalStatusList[i].value
		}
		this.getFatherStatus(this.personalDetailsData.fatherStatusId);
		this.cdr.detectChanges();
	}

	closeEditedForm() {
		this.editForm = false;
		this.cdr.detectChanges();
	}

	public getDate(date): any {
		let convertedDate = new Date(date).toISOString();
		return new Date(convertedDate).toDateString();
	}

	public async changeFileSelection(e: FileList) {
		let image = e[0];
		let test: File;
		const file = e[0];
		if (this.isValidFile(file)) {
			this.loaderService.setValue(true)
			this.cdr.detectChanges();
			// this.ng2ImgMax.compressImage(image, 0.575).subscribe(
			// 	async result => {
			// 		test = result;
			// 		await this.setAttachmentsPayload(result);
			// 		this.uploadAttachment();

			// 	},
			// 	error => {
			// 		this.loaderService.setValue(false)
			// 		this.cdr.detectChanges();
			// 	}
			// );
			const reader = new FileReader();
			reader.onload = async () => {
				const imageBase64 = reader.result as string;

				// Compress image (needs full base64 URI)
				this.imageCompress.compressFile(imageBase64, -1, 50, 50)
					.then(async (compressedImage: string) => {
						// ✅ Remove the prefix after compression
						const strippedBase64 = compressedImage.replace(/^data:image\/[a-z]+;base64,/, '');

						await this.setAttachmentsPayload(strippedBase64); // now clean
						this.uploadAttachment();
					})
					.catch((error) => {
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					});
			};
			reader.readAsDataURL(file);

		}
	}

	private isValidFile(file) {
		this.isAlertVisible = false;
		const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
		const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
		const fileSizeinKB = file.size / 1024;

		if (extensions.indexOf(ext) === -1) {
			this.isImageAlert = true;
			this.alertMsgValue = 'Error in uploading ' + file.name + ' due to invalid file type.';
			this.alertType = 'warning';
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			// this.msgPopup('Error', 'Error in uploading ' + file.name + ' due to invalid file type.','alert-error-popup')
			return false;
		} else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
			this.isImageAlert = true;
			this.alertMsgValue = 'Invalid File Name';
			this.alertType = 'warning';
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			// this.msgPopup('Error', 'Invalid File Name','alert-error-popup')
			return false;
		}
		else if (fileSizeinKB > this.maxSize) {
			this.isImageAlert = true
			this.alertMsgValue = file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.';
			this.alertType = 'warning';
			this.cdr.detectChanges();
			setTimeout(() => {
				this.isImageAlert = false;
				this.cdr.detectChanges();
			}, 3000);
			// this.msgPopup('Error', file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.','alert-error-popup')
			return false;
		}
		return true;
	}

	// private async setAttachmentsPayload(file) {
	// 	this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
	// }

	private async setAttachmentsPayload(base64: string) {
		this.attachmentBase64 = base64;
	}


	private uploadAttachment() {
		this.selectedFilePayload = '';
		this.selectedFilePayload = this.attachmentBase64;

		let payload = {
			data: this.selectedFilePayload
		}
		this.sharedServices.postUpdateProfilePicture(payload)
			.subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isImageAlert = false;
						this.cdr.detectChanges();
					}
					else {

					}
				},
				(err) => {
				}
			)
	}

	private convertFileToBase64(file): any {
		return new Promise((resolve, reject) => {
			CommonHelper.convertFileToBase64(file).then((result) => {
				resolve(result);
			})
				.catch(function (error) {
					resolve(null);
				})
		})
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public getDropdownValues(value, type) {
		if (type == 'gender') {
			this.dropdownValues.genderValue = (this.dropdownList.genderList as any).find((v: any) => v.value == value).label;
			return this.dropdownValues.genderValue;
		} else if (type == 'marital') {
			this.dropdownValues.maritalValue = (this.dropdownList.maritalStatusList as any).find((v: any) => v.value == value).label;
			return this.dropdownValues.maritalValue;
		}
		else if (type == 'country') {
			this.dropdownValues.countryValue = (this.dropdownList.countryList as any).find((v: any) => v.value == value).label;
			return this.dropdownValues.countryValue;
		}
		else if (type == 'religion') {
			this.dropdownValues.religionValue = (this.dropdownList.religionList as any).find((v: any) => v.value == value).label;
			return this.dropdownValues.religionValue;
		}
		else if (type == 'identity') {
			this.dropdownValues.identityValue = (this.dropdownList.identityTypeList as any).find((v: any) => v.value == value).label;
			return this.dropdownValues.identityValue;
		}
		else if (type == 'fatherJob') {
			this.dropdownValues.occupationList = (this.dropdownList.occupationList as any).find((v: any) => v.value == value).label;
			return this.dropdownValues.occupationList;
		}
		this.cdr.detectChanges();
	}

	addNewNationality = () => {
		this.isAddNewNationality = true;

		let initiValue = [{
			identityNo: '',
			identityTypeCode: '',
			countryId: '',
			id: '',
			primary: false,
			countryName: '',
			activeIndicator: true,
			creationTime: '',
		}];

		this.addMoreNewNationality();
		this.nationalityDetilsForm.controls.nationalityDtosNew.setValue(initiValue);
		this.cdr.detectChanges();
	}

	cancelNewNationality = () => {
		let nationalityList = this.nationalityDetilsForm.controls.nationalityDtosNew as FormArray;
		nationalityList.clear();
		this.isAddNewNationality = false;
	}

	public getNewNationality(): void {
		return this.isAddNewNationality ? this.nationalityDetilsForm.controls.nationalityDtosNew['controls'] : [];
	}

	public addMoreNewNationality(): void {
		let nationalityList = this.nationalityDetilsForm.controls.nationalityDtosNew as FormArray;
		nationalityList.push(this.createNewNationalityRow());
	}
}
